"use client";

import { useQuery } from "@tanstack/react-query";
import { getActiveOrganisation } from "@/lib/auth/org-context";

/**
 * Client hook for accessing the active organisation
 * Returns the organisation with user's role
 */
export function useActiveOrganisation() {
  return useQuery({
    queryKey: ["active-organisation"],
    queryFn: getActiveOrganisation,
    staleTime: 30 * 1000, // Reduced to 30 seconds for better role updates
    refetchOnMount: true, // Always refetch when component mounts
    refetchOnWindowFocus: true, // Refetch when window regains focus
  });
}
